import React from 'react'

interface IconProps {
  className?: string
}

const AI = ({ className }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    className={className}
  >
    <defs>
      <linearGradient id="aiIconGradient" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#FF3CAC" />
        <stop offset="100%" stopColor="#784BA0" />
      </linearGradient>
    </defs>
    <g transform="scale(0.4)">
      <path
        d="M26.6875 12.6602c0.2812 0 0.4219-0.1641 0.4922-0.4219 0.7266-3.9141 0.6797-4.0078 4.7578-4.7813 0.2812-0.0469 0.4453-0.2109 0.4453-0.4922s-0.1641-0.4219-0.4453-0.4688c-4.0547-0.8203-3.9375-0.9141-4.7578-4.7813-0.0703-0.2578-0.2109-0.4219-0.4922-0.4219s-0.4219 0.1641-0.4922 0.4219c-0.8203 3.8672-0.6797 3.9648-4.7578 4.7852-0.2578 0.0469-0.4453 0.2109-0.4453 0.4922 0 0.2813 0.1875 0.4453 0.4453 0.4922 4.0781 0.8203 4.0312 0.9063 4.7578 4.8203 0.0703 0.2578 0.2109 0.4219 0.4922 0.4219zM15.3438 28.7852c0.4453 0 0.75-0.2813 0.7969-0.7031 0.8438-6.2578 1.0547-6.2578 7.5234-7.5 0.4219-0.0703 0.7266-0.3516 0.7266-0.7969s-0.3047-0.7266-0.7266-0.7969c-6.4688-0.8906-6.7031-1.1016-7.5234-7.4766-0.0469-0.4219-0.3516-0.7266-0.7969-0.7266s-0.7266 0.3047-0.7812 0.75c-0.7734 6.2813-1.1016 6.2578-7.5234 7.4531-0.4219 0.0938-0.7266 0.3516-0.7266 0.7969s0.3047 0.7266 0.7266 0.7969c6.375 1.0313 6.6563 1.1953 7.4297 7.4531 0.0469 0.4688 0.3516 0.75 0.7734 0.75zM31.2344 54.7305c0.6094 0 1.0547-0.4453 1.1719-1.0781 1.6641-12.8438 3.4688-14.7891 16.1719-16.1953 0.6562-0.0703 1.1016-0.5625 1.1016-1.1719s-0.4453-1.0781-1.1016-1.1484c-12.7031-1.4063-14.5078-3.3516-16.1719-16.1953-0.1172-0.6328-0.5625-1.0547-1.1719-1.0547s-1.0547 0.4219-1.1719 1.0547c-1.6641 12.8438-3.4922 14.7891-16.1719 16.1953-0.6797 0.0938-1.125 0.5625-1.125 1.1719s0.4453 1.0781 1.125 1.1484c12.6563 1.6641 14.4141 3.375 16.1719 16.1953 0.1172 0.6328 0.5625 1.0781 1.1719 1.0781z"
        fill="url(#aiIconGradient)"
        stroke="none"
      />
    </g>
  </svg>
)

export default AI
